// lastAuthMethod — minneshjälp för att kunna pre-välja rätt
// sign-in-flik / highlighta rätt OAuth-knapp nästa gång user kommer
// tillbaka. Lokal localStorage-flag (per device, inte cross-device);
// rensas vid signOut för säkerhets skull. (#55)

const STORAGE_KEY = 'fw.lastAuthMethod.v1';

export type AuthMethod = 'email' | 'google' | 'azure' | 'github';

export function rememberAuthMethod(method: AuthMethod): void {
  try {
    localStorage.setItem(STORAGE_KEY, method);
  } catch {
    // localStorage quota / private mode — silently no-op; the hint is
    // a UX nicety, not a correctness invariant.
  }
}

export function readLastAuthMethod(): AuthMethod | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'email' || raw === 'google' || raw === 'azure' || raw === 'github') {
      return raw;
    }
    return null;
  } catch {
    return null;
  }
}

export function forgetAuthMethod(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
